import React from 'react'
import Select from "react-select";
import { useTranslation } from "react-i18next";

const NewCatalogRelationGeneric = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation, comboData, level, css_class }) => {

  const { t } = useTranslation();

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
      whiteSpace: "normal"
    }),
    control: (provided) => ({
      ...provided,
      minHeight: 54,
      height: "auto",
      alignItems: "flex-start",
      borderColor: errors?.[field] ? "#dc3545" : provided.borderColor,
      boxShadow: errors?.[field] ? "0 0 0 1px #dc3545" : provided.boxShadow
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "auto",
      paddingTop: 8,
      paddingBottom: 8
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
      whiteSpace: "normal",
      position: "static",
      transform: "none",
      maxWidth: "100%",
      overflow: "visible"
    }),
  };

  return (   
    <div className={`col-md-${occupation} ${css_class}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}</label>
      <div className="control">
        <Select
          styles={customStyles}
          myFontSize="14px"
          onChange={(event) => handleChange(event, level)}
          
          className={`form-control txt-view ${errors[field] && "border border-danger"}`}
          classNamePrefix="select"
          name={field}
          
          inputId={field}
          
          value={values[field]}
          
          options={comboData}
          getOptionLabel={(option) => `${option.code} - ${option.name}`}
          getOptionValue={(option) => `${option}`}
          isClearable={true}
          isSearchable={true}
          placeholder={placeholderVal ? t("combo.placeholder") : null}
        />
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewCatalogRelationGeneric;